export const Resources = {
  path: '/resources',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'resources',
      component: () => import('pages/resources/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.resources.name',
        path: '/resources',
        condition: 'resource',
      },
    },
    {
      path: 'create',
      name: 'resources-create',
      component: () => import('pages/resources/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: '新規作成',
        parents: [
          {
            title: 'page.resources.name',
            path: '/resources',
            condition: 'resource',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'resources-id',
      component: () => import('src/pages/resources/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.resources.name',
            path: '/resources',
            condition: 'resource',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'resources-id-edit',
      component: () => import('src/pages/resources/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.resources.name',
            path: '/resources',
            condition: 'resource',
          },
          {
            title: ':name',
            path: '/resources/:id',
          },
        ],
      },
    },
  ],
};
